import io from "socket.io-client";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let socket=null;
let connected = false;
let fingerprint = null;



export default class SocketHandler{



    constructor(processResultCallback, fullResultCallback) {
        const ENDPOINT = process.env.REACT_APP_APIURL;
        console.log(ENDPOINT)
        if(!this.socket){
            this.socket= io(ENDPOINT);
        }


        //this.createFingerprint();
        this.initialize();
        this.processResultCallback = processResultCallback;
        this.fullResultCallback = fullResultCallback;

    }

    async createFingerprint(){
        //let fp = await FingerprintJS.load();
       // this.fingerprint = await fp.get()
    }

    initialize(){
        this.socket.on("track-query", data => {
            this.processResultCallback(data);
        });

        this.socket.on("track-result", data => {
            this.fullResultCallback(data);
        });
    }

    track(trackingNrArr){
        let fingerprint=null;
        if(this.fingerprint){
            fingerprint =this.fingerprint.visitorId
        }
        console.log('[EMIT] - track')
        this.socket.emit('track', {
            trackingNrArr: trackingNrArr,
            f: fingerprint
        })
    }




}

//module.exports = SocketHandler;
